export function AboutPage() {
  return (
    <article className="mx-auto max-w-3xl px-4 py-14">
      <h1 className="text-3xl font-bold text-ink-900">About STEM Africa Learning Hub</h1>

      <p className="mt-4 text-ink-700">
        STEM Africa Learning Hub is a subsidiary of <strong>VISINA Consult Limited</strong>, an
        education leader in dynamic learning management systems for educators, learners, teacher
        trainers, administrators and education officials across Africa.
      </p>

      <h2 className="mt-8 text-xl font-semibold text-ink-900">Our vision</h2>
      <p className="mt-2 text-ink-700">
        To become Africa's leading digital platform for STEM professional learning, innovative
        teaching resources, virtual laboratories and collaborative communities supporting quality
        Competency-Based Education.
      </p>

      <h2 className="mt-8 text-xl font-semibold text-ink-900">How the platform is built</h2>
      <p className="mt-2 text-ink-700">
        Three decisions shape everything a user sees, and each of them is about the realities of
        African classrooms rather than about software fashion.
      </p>

      <dl className="mt-4 space-y-5">
        <div>
          <dt className="font-semibold text-ink-900">Laboratories are written, not coded.</dt>
          <dd className="mt-1 text-ink-700">
            Every virtual laboratory is a declarative script interpreted by one runtime. That is what
            makes twenty-two laboratories a programme of authoring rather than twenty-two
            applications — and it is why the same experiment can render as an animated scene, a
            simple diagram, or a described table without the assessment changing at all.
          </dd>
        </div>

        <div>
          <dt className="font-semibold text-ink-900">Institutions are a tree, not a list.</dt>
          <dd className="mt-1 text-ink-700">
            A ministry contains counties, which contain schools, which contain departments and
            classes. Reports roll up that tree, so a national dashboard and a single school's
            dashboard are the same question asked at different heights.
          </dd>
        </div>

        <div>
          <dt className="font-semibold text-ink-900">Curricula arrive as packs.</dt>
          <dd className="mt-1 text-ink-700">
            A curriculum pack carries outcomes, courses and laboratories as data. Onboarding a
            ministry is an installation, not a migration — and installing it twice changes nothing
            that is already there.
          </dd>
        </div>
      </dl>

      <h2 className="mt-8 text-xl font-semibold text-ink-900">Where your data lives</h2>
      <p className="mt-2 text-ink-700">
        Each organisation's learners, progress and content are separated at the database itself, not
        only in application code. A query that forgets which school it is asking about returns
        nothing rather than somebody else's records. For ministries with residency requirements, a
        deployment can be pointed at its own database without redesign.
      </p>
    </article>
  );
}
